import { ENV } from "@/constants/env";
import { TelephonyProviderId } from "@/features/telephony/interfaces/telephony-provider.interface";

const REGISTERED_PROVIDER_IDS: TelephonyProviderId[] = ["twilio", "vonage"];

const isTelephonyProviderId = (value: string | undefined): value is TelephonyProviderId => {
    return REGISTERED_PROVIDER_IDS.some((providerId) => providerId === value);
};

export const getDefaultTelephonyProviderId = (): TelephonyProviderId => {
    if (isTelephonyProviderId(ENV.TELEPHONY_PROVIDER)) {
        return ENV.TELEPHONY_PROVIDER;
    }

    return "twilio";
};
